import React from "react";
import { Redirect, withRouter } from "react-router-dom";

import { workspaces as workspacesApi } from "apis/callables";
import { Error } from "js/app/Error";
import ErrorMessage from "js/app/ErrorMessage";
import { serverContext } from "js/config";
import { setPersistentWorkspaceId } from "js/controllers/WorkspaceController";
import getLogger, { LogGroup } from "js/core/logger";
import getLocalStorage from "js/core/utilities/localStorage";
import { trackActivity } from "js/core/utilities/utilities";
import { LoadingPage } from "js/react/components/LoadingPage";
import { withFirebaseUser } from "js/react/views/Auth/FirebaseUserContext";

const logger = getLogger(LogGroup.INVITES);

const localStorage = getLocalStorage();

class Invite extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: "pending"
        };
    }

    async componentDidMount() {
        const user = this.props.firebaseUser;
        const { inviteId } = this.props.match.params;
        const { inviteType, fromUser, redirect: unsafeRedirect, email, form, presentationPermission } = serverContext;

        const redirect = unsafeRedirect.startsWith("http")
            ? new URL(unsafeRedirect).pathname
            : unsafeRedirect;

        // email verify link tracking
        const hasSignupParam = new URL(redirect, "http://base").searchParams.get("signup") === "true";
        let isNewUser = hasSignupParam || form == "signup";

        if (inviteType == "share") {
            if (presentationPermission === "secured" && email !== user.email) {
                isNewUser = false;
            }
            this.handleShareInvite(redirect, isNewUser);
        } else if (inviteType == "collaboration") {
            this.handleCollaborationInvite(redirect, inviteId, fromUser, isNewUser);
        } else if (inviteType == "team") {
            this.handleTeamInvite(redirect, inviteId);
        } else {
            this.setState({ status: "failed", error: `Unknown invite type: ${inviteType}` });
        }
    }

    render() {
        switch (this.state.status) {
            case "pending":
                return (
                    <LoadingPage />
                );
            case "succeeded":
                // hack due to the player still needing serverContext but we don't want to navigate,
                // ideally the player could figure this out for itself
                if (this.state.url != "/") {
                    window.serverContext.contextId = this.state.url.match(/[A-Za-z0-9_-]{20}/)[0];
                }
                return (
                    <Redirect to={this.state.url} />
                );
            case "failed":
                return (
                    <ErrorMessage message={this.state.error} />
                );
            case "error":
                return <Error title={this.state.title} message={this.state.message} />;
        }
    }

    handleShareInvite = (redirectUrl, isNewUser) => {
        window.baiSource = "secureshare";
        this.setState({ status: "succeeded", url: redirectUrl });
    }

    handleCollaborationInvite = (redirectUrl, inviteId, fromUser, isNewUser) => {
        workspacesApi.applyCollaborationInvite({ inviteId })
            .then(({ workspaceId }) => {
                setPersistentWorkspaceId(workspaceId);

                const isViewOnly = /\/player\//.test(redirectUrl); // TODO: server should tell us this, don't make the client infer it.
                if (isNewUser) {
                    trackActivity("Collab", "Signup", null, 1, {
                        fromUser: fromUser,
                        permission: isViewOnly ? "view" : "edit",
                        workspace_id: "personal"
                    }, { audit: true });
                }
                window.baiSource = "collab:" + (isViewOnly ? "view" : "edit");
                this.setState({ status: "succeeded", url: redirectUrl });
            })
            .catch(err => {
                logger.error(err, "handleCollaborationInvite() failed", { redirectUrl, inviteId, fromUserUid: fromUser?.uid, isNewUser });
                this.setState({ status: "failed", error: err.message });
            });
    }

    handleTeamInvite = (redirectUrl, inviteId) => {
        workspacesApi.applyWorkspaceUserInvite({ inviteId })
            .then(({ workspaceId }) => {
                setPersistentWorkspaceId(workspaceId, "JOINED");

                trackActivity("Organization", "Joined", null, null, { workspace_id: workspaceId });
                window.baiSource = "team-invite";
                this.setState({ status: "succeeded", url: redirectUrl });
            })
            .catch(err => {
                logger.error(err, "handleTeamInvite() failed", { redirectUrl, inviteId });
                this.setState({ status: "failed", error: err.message });
            });
    }
}

export default withRouter(withFirebaseUser(Invite));
